export const CONTACT_US_FORMS_ROUTE = '/contact-us/contact-us-forms'
export const ADD_CONTACT_US_FORM_ROUTE = '/contact-us/add-contact-us-form'
export const CONTACT_US_FORM_SUBMISSION_ROUTE =
  '/contact-us/add-contact-us-form-submission'
export const CONTACT_US_MESSAGES_ROUTE = '/contact-us/contact-messages'
export const CONTACT_US_SPAM_MESSAGES_ROUTE =
  '/contact-us/contact-spam-messages'
export const CONTACT_US_DETAILS_ROUTE = '/contact-us/contact-messages/:id'
